export interface TextLocalization {
  logoTitle: string;
  errorHeader: string;
  errorContent: string;
  errorPrimary: string;
  timeoutHeader: string;
  timeoutContent: string;
  timeoutPrimary: string;
  inputPlaceholder: string;
  inputCountryCodeLabel: string;
  countryCodeSelectorLabel: string;
  inputInputLabel: string;
  inputPrimary: string;
  inputPrimaryLabel: string;
  useSavedNumberButton: string;
  continueAsLabel: string;
  useAnotherNumberLabel: string;
  rememberMeLabel: string;
  inputCancel: string;
  inputCancelLabel: string;
  inputError: string;
  inputErrorNoEdit: string;
  scanToOpenInKlarna: string;
  addKlarna: string;
  openVipps: string;
  openInKlarnaMobileText: string;
  statusHeader: string;
  statusContent: string;
  statusNumberFallback: string;
  statusAriaLabel: string;
  qrAltTag: string;
  qrSeparator: string;
  dropDownOptionsLabel: string;
  localeSelectorLabel: string;
  upgradeApp: string;
  cookieDeclarationText: string;
  cookieDeclarationLink: string;
  cookieDeclaration: string;
  scanToPay: string;
  paymentTo: string;
  skipToContent: string;
  inputHeadingAmount: string;
  inputHeadingRecurring: string;
  inputDescription: string;
  inputDescriptionQr: string;
}

interface CountryLocale {
  country: string;
  language: string;
}

export interface CountryLocalizations {
  greenland: CountryLocale;
  britain: CountryLocale;
  norway: CountryLocale;
  denmark: CountryLocale;
  finland: CountryLocale;
  sweden: CountryLocale;
}

export const Locale = {
  EN: 'en-GB',
  NO: 'no-NO',
  FI: 'fi-FI',
  DK: 'da-DK',
} as const;
export type Locale = (typeof Locale)[keyof typeof Locale];
